// extracted by css-extract-rspack-plugin
export default {"trail":"trail-tPcLGg","link":"link-UnMM_3","current":"current-nwzB2x","separator":"separator-Z1ngU1","total":"total-VsxKQl"};